import { Field } from 'formik'

const RadioField = ({ name, options = [] }) => {
  return (
    <div className="mt-3 space-y-3">
      {options.map((option, index) => (
        <label key={index} className="flex items-start gap-3 cursor-pointer">
          <Field
            type="radio"
            name={name}
            value={option.value}
            className="mt-1 h-4 w-4 text-brandSecondary focus:ring-brandSecondary border-brandSecondary"
          />
          <div className="flex-1">
            <div className="font-medium text-gray-900">{option.label}</div>
            {option.description && (
              <div className="text-sm text-gray-600 mt-1">{option.description}</div>
            )}
          </div>
        </label>
      ))}
    </div>
  )
}

export default RadioField